<template>
  <v-app-bar app clipped-left>
    <v-app-bar-nav-icon @click.stop="drawerChange"></v-app-bar-nav-icon>
    <v-btn
      icon
      class="hidden-xs-only mr-2 ml-2"
      v-if="!isHomeRoute"
      @click.prevent="backButtonClick"
    >
      <v-icon size="30">arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title>{{ this.currentRootTitle }}</v-toolbar-title>
  </v-app-bar>
</template>

<script>
export default {
  components: {},

  props: {
    source: String,
    drawer: Boolean
  },

  data: () => ({
    drawerLocal: null
  }),

  created() {
    this.$vuetify.theme.dark = true
  },

  methods: {
    backButtonClick: function(e) {
      let path = e.path || e.composedPath()
      path[1].blur()
      this.$router.go(-1)
    },
    drawerChange() {
      this.drawerLocal = !this.drawerLocal
      this.$emit('drawerChange', this.drawerLocal)
    }
  },
  computed: {
    currentRootTitle() {
      return this.$route.name
    },
    isHomeRoute() {
      return this.$route.path === '/'
    }
  },
  watch: {
    drawer: function(newValue) {
      this.drawerLocal = newValue
    }
  }
}
</script>
